// removed by extract-text-webpack-plugin
module.exports = {"home":"_32Ow","homeContainer":"_3J3u","container":"_1So3"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/home/style.css
// module id = 141
// module chunks = 9